<template>
  <div class="input-item">
    <ul class="input-item__list">
      <li>
        <span class="input-item__label">メニュー</span>
        <span class="input-item__data">{{ item.name }}</span>
      </li>
      <li>
        <span class="input-item__label">申込日</span>
        <span class="input-item__data">{{ item.date }}<small>({{ item.dayOfWeek}})</small></span>
      </li>
      <li>
        <span class="input-item__label">価格</span>
        <span class="input-item__data">
          10分まで¥{{ price | addComma }}<small>(税込)</small>、<br>
          延長は1分毎 ¥100<small>(税込)</small>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InputItem',
  props: {
    item: Object,
    user: Object,
    price: Number,
  },
}
</script>

<style lang="scss" scope>
@import '../../../../../sass/commons/commonVariables.scss';

.input-item {
  &__list {
    padding: 0;
    margin: -10px auto;
    > li {
      display: flex;
      align-items: center;
      border-top: 1px dashed #EFF4F7;
      padding: 10px 0;
      &:first-child {
        border: none;
      }
    }
  }
  &__label {
    flex: 0 0 72px;
    font-size: 11px;
    line-height: 16px;
    color: #CDB0A1;
    display: inline-block;
  }
  &__data {
    font-size: 13px;
    line-height: 1.46;
    small {
      font-size: 11px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/partials/InputItem.vue